import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { BTN_WHITE, INPUT, errText } from "./AdminModal";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// Image link input with an Upload button; uploads land in storage and fill in the link.
export function ImageUploadField({ value, onChange, placeholder, max, testId }) {
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/site-images", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (e) {
      toast.error(errText(e, "Couldn't upload the image"));
    } finally {
      setBusy(false);
    }
  };
  const src = value && value.startsWith("/api/") ? `${BACKEND}${value}` : value;
  return (
    <div className="mt-1 flex items-center gap-2">
      {src && <img src={src} alt="" className="h-9 w-9 shrink-0 border-2 border-black object-cover" data-testid={`${testId}-thumb`} />}
      <input className={`${INPUT} mt-0`} value={value || ""} maxLength={max} placeholder={placeholder}
             onChange={(e) => onChange(e.target.value)} data-testid={testId} />
      <label className={`${BTN_WHITE} shrink-0 cursor-pointer`}>
        {busy ? "Uploading…" : "Upload"}
        <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" disabled={busy}
               onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} data-testid={`${testId}-upload`} />
      </label>
    </div>
  );
}
